import { ENV } from '../reactor/common/index';
import { C } from './index';

export default (serverHostname) => {
  const { IS_WEB, IS_SERVER } = ENV;
  const { CLIENT_DOMAINS: { EROSKI: { DOMAIN } } } = C;
  return (
    (IS_WEB && !IS_SERVER && window.location.host === DOMAIN)
    || (IS_WEB && IS_SERVER && serverHostname !== undefined && serverHostname === DOMAIN)
  );
};
